import { PortOperations } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const PORT_OPERATIONS_DATA_TAG = 'CargoOperation';
export default class PortOperationsParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.IN_PORT_PORT_OPERATIONS, FIXED_PROTOCOL_CONTENT_TYPE_IDS.IN_PORT_PORT_OPERATIONS, PORT_OPERATIONS_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            portName: 'portName',
            operationStatus: 'operationStatus',
            cargoType: 'cargoType',
            cargoAmount: 'cargoAmount',
            passengerCount: 'passengerCount',
            crewCount: 'crewCount',
            freeText: 'freeText',
        };
    }
    createData(props) {
        return new PortOperations(props.portName, props.operationStatus, props.cargoType, props.cargoAmount, props.passengerCount, props.crewCount, props.freeText);
    }
}
//# sourceMappingURL=PortOperationsParser.js.map